export const listPaymentProfiles = `
   query listPaymentProfiles($filter: PaymentProfilesFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listPaymentProfiles(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              description
              customerId
              status
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getPaymentProfile = `
   query getPaymentProfile($id:ID!) {
       getPaymentProfile(id:$id) {
         id
         name
         description 
         customerId
         status
         created
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         updated
       } 
}`;
